import APIClient from '@/shared/http/clients/api'

const resourceName = 'promessas'
const APICore = process.env.APIBaseURLCore

/**
 * Repository para Promessas de Pagamento
 * Melhoria 8.697 - Promessa de Pagamento por Parcela
 */

/**
 * Cria promessa para uma ou mais parcelas
 * @param {Object} data - { parcelaIds, dataPagamentoPrometida, observacoes, cardId, criarFollowup }
 */
const criarPromessa = (data = {}, config = {}) =>
  APIClient.post(`${APICore}/${resourceName}/`, data, config)

/**
 * Atualiza status de uma promessa
 * @param {Number} id - ID da promessa
 * @param {Object} data - { status, observacoes }
 */
const atualizarStatus = (id, data = {}, config = {}) =>
  APIClient.patch(`${APICore}/${resourceName}/${id}/status`, data, config)

/**
 * Busca promessas de um card
 * @param {Number} cardId - ID do card
 */
const getPromessasByCard = (cardId, config = {}) =>
  APIClient.get(`${APICore}/${resourceName}/card/${cardId}`, config)

/**
 * Busca promessa de uma parcela específica
 * @param {Number} parcelaId - ID da parcela
 */
const getPromessaByParcela = (parcelaId, config = {}) =>
  APIClient.get(`${APICore}/${resourceName}/parcela/${parcelaId}`, config)

/**
 * Marca promessa como CUMPRIDA manualmente
 * @param {Number} id - ID da promessa
 */
const marcarComoCumprida = (id, config = {}) =>
  APIClient.post(`${APICore}/${resourceName}/${id}/marcar-cumprida`, {}, config)

/**
 * Busca promessas detalhadas de um card (para aba Promessas)
 * @param {Number} cardId - ID do card
 */
const getPromessasDetalhadasByCard = (cardId, config = {}) =>
  APIClient.get(`${APICore}/${resourceName}/card/${cardId}/detalhadas`, config)

/**
 * Atualiza uma promessa existente (edição completa)
 * @param {Number} id - ID da promessa
 * @param {Object} data - { dataPagamentoPrometida, observacoes, diasAntesAlerta, boardColumnDestinoId, enviarEmailAlerta, enviarWhatsAppAlerta }
 */
const atualizarPromessa = (id, data = {}, config = {}) =>
  APIClient.put(`${APICore}/${resourceName}/${id}`, data, config)

/**
 * Cancela uma promessa (deleta logicamente)
 * @param {Number} id - ID da promessa
 */
const cancelarPromessa = (id, config = {}) =>
  APIClient.delete(`${APICore}/${resourceName}/${id}`, config)

/**
 * Calcula o status visual de um card baseado em suas promessas
 * @param {Number} cardId - ID do card
 */
const getStatusVisualCard = (cardId, config = {}) =>
  APIClient.get(`${APICore}/${resourceName}/card/${cardId}/status-visual`, config)

const PromessaRepository = {
  criarPromessa,
  atualizarStatus,
  atualizarPromessa,
  marcarComoCumprida,
  cancelarPromessa,
  getPromessasByCard,
  getPromessasDetalhadasByCard,
  getPromessaByParcela,
  getStatusVisualCard
}

export default PromessaRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/promessa/PromessaRepository.js